import {
  BaseFieldObject,
  NullEcommerceEvent,
  RecommendedProduct,
} from '@noths/polaris-dev-ts-types';

import {
  ContactSellerEvent,
  MarketingPreferencesEvent,
  PartnerStorefrontEvent,
  ProductEventWithEcommerce,
} from 'src/types';

export const PARTNER_STOREFRONT_VISIBILITY_NAME = 'partnerStorefront';
export const MARKETING_PREFERENCES_VISIBILITY_NAME = 'marketingPreferences';

export interface PartnerStorefrontImpression extends PartnerStorefrontEvent {
  event: 'custom_event';
  event_category: 'Seller shelf';
  event_action: 'Impression';
  event_label: 'not set';
}

export interface PartnerStorefrontNameClick extends PartnerStorefrontEvent {
  event: 'custom_event';
  eventCallback: () => void;
  eventTimeout: number;
  event_action: 'Partner storefront click';
  event_category: 'Seller shelf';
  event_label: 'Partner name';
  destination_URL: string;
}

export interface PartnerStorefrontLinkClick extends PartnerStorefrontEvent {
  event: 'custom_event';
  event_action: 'Partner storefront click';
  event_category: 'Seller shelf';
  event_label: 'Partner logo' | 'Partner name' | 'Visit shop CTA';
  destination_URL: string;
}

export interface MarketingPreferencesImpression extends MarketingPreferencesEvent {
  event: 'custom_event';
  event_category: 'Marketing preferences';
  event_action: 'Impression';
  event_label: 'Contact seller';
}

export type PartnerNamePayload = string;

export interface ContactSellerOpenModal extends ContactSellerEvent {
  event: 'custom_event';
  event_action: 'Click';
  event_category: 'Contact seller';
  event_label: PartnerNamePayload;
}

export interface ContactSellerSubmit extends ContactSellerEvent {
  event: 'custom_event';
  event_action: 'Submit';
  event_category: 'Contact seller';
  event_label: PartnerNamePayload;
}

export interface MarketingPreferencesSubmit extends MarketingPreferencesEvent {
  event: 'custom_event';
  event_category: 'Marketing preferences';
  event_action: 'Subscribe';
  event_label: 'Contact seller';
  user_email: string;
}

export interface ContactSellerCloseModal extends ContactSellerEvent {
  event: 'custom_event';
  event_action: 'Close';
  event_category: 'Contact seller';
  event_label: PartnerNamePayload;
}

export type FieldValidationErrorPayload = string;

export interface PartnerStorefrontLinkClickPayload
  extends Pick<PartnerStorefrontLinkClick, 'destination_URL' | 'event_label'> {
  useEventCallback: boolean;
}

export type PartnerProductCardsVisiblePayload = {
  products: RecommendedProduct[];
};

export interface ContactSellerFieldValidationError {
  event: 'custom_event';
  event_action: 'Error';
  event_category: 'Contact seller';
  event_label: FieldValidationErrorPayload;
}

interface ShelfProductClickEcommerce {
  ecommerce: {
    click: {
      actionField: {
        list: string;
      };
      products: BaseFieldObject[];
    };
  };
}

export type InitialRelatedProductClickEvent = NullEcommerceEvent;

export interface RelatedProductClick
  extends ProductEventWithEcommerce<
    'product_clicks',
    'Product Click',
    string,
    ShelfProductClickEcommerce
  > {
  event_category: 'Rich Relevance';
  eventCallback?: () => void;
  eventTimeout?: number;
  algonomy_tracking_URL: string;
}

export interface PartnerProductCardsVisible {
  event: 'product_impressions';
  event_category: 'Rich Relevance';
  event_action: 'Product Impressions';
  event_label: string;
  ecommerce: {
    impressions: BaseFieldObject[];
  };
}
